import React from 'react';
import { ShippingOrder } from '../../DeShippingTableWrapper';

// Date template - displays formatted date with days since creation
export const dateTemplate = (rowData: ShippingOrder) => {
  const createdDate = new Date(rowData.created_at);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - createdDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  // Format date as MM/DD/YYYY
  const formattedDate = createdDate.toLocaleDateString('en-US');
  
  // Determine color based on days
  let dayColor = '';
  if (diffDays < 2) {
    dayColor = 'text-success';
  } else if (diffDays <= 4) {
    dayColor = 'text-warning';
  } else {
    dayColor = 'text-danger';
  }
  
  return (
    <div className="date-info">
      <div className="fw-bold">{formattedDate}</div>
      <div className={`small ${dayColor}`}>
        {diffDays} day{diffDays !== 1 ? 's' : ''} since order created
      </div>
    </div>
  );
};